import { errorThatWillCauseAlert } from "owa-trace";

import { getControlBehavior } from "./data/getControlBehavior";
import { NovaControlModelDocument } from "./graphql/query/__generated__/NovaControlModel.interface";

import type { LaunchTileBehaviorParams } from "./launchTileBehaviorParams";
import { writeQuery } from "owa-apollo";

export function bootstrapNovaCache(params?: LaunchTileBehaviorParams): void {
    try {
        const controlModelBehavior = getControlBehavior(params);
        writeQuery(NovaControlModelDocument, { data: controlModelBehavior });
    }
    catch (e) {
        // Errors resulting from enabling useUnknownInCatchVariables
        // TS2345: Argument of type 'unknown' is not assignable to parameter of type 'TraceErrorObject | undefined'.
        // @ts-expect-error
        errorThatWillCauseAlert("AppBar_CachePriming_Error", e);
    }
}
